import _RentalInvoiceService from "../services/rental-invoice-approval-service";
import { IRentalInvoiceApprovalService } from "../types/services/rental-invoice-approval-service";

const instance = new _RentalInvoiceService();

const RentalInvoiceApprovalService: IRentalInvoiceApprovalService = instance;

export default RentalInvoiceApprovalService;
